module.exports = __webpack_public_path__ + "dash_20_app_assets/img/dtwireframe.8059e976.png";